import * as Yup from 'yup';

import { toI18n } from 'util/i18n';

export const phoneSchema = {
  phone: Yup.string()
    .matches(/^\d{10}$/, toI18n('fe_design_base.errors.field.phone_invalid'))
    .required(toI18n('fe_design_base.errors.field.phone_required')),
};
